import React from 'react';
import { getParsedData } from '../../utils/general';
import { IPopoverProps } from '../../interfaces/interfaces/components/IEpButtonVision';
import { EpPopover } from '../EpPopover';
import { EpAvatar } from '../EpAvatar';
import { EpIconSolidExternalLinkAlt } from '../EpIcon/variants/solid/EpIconSolidExternalLinkAlt/EpIconSolidExternalLinkAlt';
import './EpButtonVision.scss';

interface EpButtonVisionProps {
  buttonVisionId: string;
  customClasses?: string;
  buttonVisionDataBsToggle?: string;
  buttonVisionAriaExpanded?: boolean;
  buttonVisionDataBsAutoClose?: boolean;
  buttonVisionDataBsTarget?: string;
  buttonVisionAriaControls?: string;
  buttonVisionDataBsDismiss?: string;
  buttonVisionAriaLabel?: string;
  buttonOnClickFunc?: (args?: unknown) => void;
  buttonVisionPopoverProps: IPopoverProps | string;
}

export const EpButtonVision: React.FC<EpButtonVisionProps> = (props) => {
  const {
    buttonVisionId,
    customClasses = '',
    // buttonVisionDataBsToggle = '',
    // buttonVisionAriaExpanded = false,
    // buttonVisionDataBsAutoClose = false,
    // buttonVisionDataBsTarget = '',
    // buttonVisionAriaControls = '',
    // buttonVisionDataBsDismiss = '',
    // buttonVisionAriaLabel = '',
    buttonOnClickFunc,
  } = props;

  const parsedPopoverProps: IPopoverProps = getParsedData(
    props.buttonVisionPopoverProps,
  );

  return (
    <div
      className={`ep-button-vision ${customClasses}`}
      data-button-vision-id={buttonVisionId}
    >
      <EpPopover
        popoverId={parsedPopoverProps.id}
        popoverHostId={parsedPopoverProps.hostId}
        popoverPlacement={'bottom-start'}
        popoverContentType={'interactive-html'}
        popoverEventType="hover"
        customClasses="ep-button-vision__popover"
        selectorsToDismissPopover={['ep-nav-highlight']}
        triggerPopover={
          <button
            slot="trigger-popover"
            type="button"
            className="ep-button-vision__popover-trigger popover__trigger"
            onClick={() => buttonOnClickFunc?.()}
          >
            <EpAvatar
              avatarId={parsedPopoverProps.triggerAvatarId}
              avatarSize="sm"
              avatarContent="icon"
              avatarIconName={parsedPopoverProps.iconNameByRole}
            />
            <span className="ep-button-vision__popover-trigger-text">
              {parsedPopoverProps.triggerText}
            </span>

            <EpIconSolidExternalLinkAlt iconSize={16} />
          </button>
        }
        popoverBodyContent={
          <div
            slot="popover-body-content"
            className="ep-button-vision__popover-content"
          >
            <EpAvatar
              avatarId={parsedPopoverProps.avatarId}
              avatarSize="lg"
              avatarContent="icon"
              avatarIconName={parsedPopoverProps.iconNameByRole}
            />

            <div className="info">
              <h4 className="info__institution">
                Instituição/Hospital{' '}
                {/** @TODO - Inserir termo no globalization */}
              </h4>

              <h3 className="info__hospital">
                {parsedPopoverProps.institutionName}
              </h3>

              <h5 className="info__role">{parsedPopoverProps.role}</h5>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default EpButtonVision;
